module.exports = __webpack_public_path__ + "img/17_Sound Decision Maker.00934056.svg";